import React, { useContext, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { LayoutContext } from "App/common/hoc/Layout";
import ShowHidePassword from "App/common/ui/ShowHidePassword";
import { objectToArray, checkValidity, checkPassStrength } from "utils";
import { updatePasswordStart, updatePasswordResetState } from "store/actions";
import { VALIDATION } from "consts";

function ChangePassword(props) {
  const { lMethods, lState } = useContext(LayoutContext);

  const [passwordStrength, setPasswordStrength] = useState("");
  const [form, setForm] = useState({
    oldPassword: {
      key: "oldPassword",
      title: "Current Password",
      type: "password",
      value: "",
      validation: { required: true, isPassword: true },
      valid: true,
      error: ""
    },
    newPassword: {
      key: "newPassword",
      title: "New Password",
      type: "password",
      value: "",
      validation: {
        required: true,
        isNewPass: true,
        isPassword: true
      },
      valid: true,
      error: ""
    },
    confirmNew: {
      key: "confirmNew",
      title: "Confirm New Password",
      type: "password",
      value: "",
      validation: {
        required: true,
        isConfirmNewPass: true,
        isPassword: true
      },
      valid: true,
      error: ""
    }
  });

  useEffect(() => {
    return () => {
      props.updatePasswordResetState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    lMethods.updatePopupParams({
      execute: formSubmitHandler
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    lMethods.updatePopupParams({
      loading: props.changePassword.loading,
      error: props.changePassword.error
    });

    if (props.changePassword.updated) lMethods.closePopup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.changePassword]);

  function inputChangeHandler(key, value) {
    const updatedForm = { ...form };
    const updatedInput = { ...updatedForm[key] };

    updatedInput.value = value.trim();

    if (key === "newPassword") {
      setPasswordStrength(checkPassStrength(value));
    }

    updatedInput.error = "";
    updatedForm[key] = updatedInput;

    setForm(updatedForm);
  }

  function formSubmitHandler() {
    let isFormValid = true;
    const updatedForm = { ...form };
    const updatedPasswordDetails = {};
    let oldPassword = "";
    let newPassword = "";

    for (let key in updatedForm) {
      const updatedInput = { ...updatedForm[key] };

      const validationObj = checkValidity(
        updatedInput.value ? updatedInput.value : "",
        updatedInput.validation,
        key
      );
      if (updatedInput.key === "oldPassword") oldPassword = updatedInput.value;
      if (updatedInput.key === "newPassword") newPassword = updatedInput.value;
      updatedInput.valid = validationObj.isValid;
      updatedInput.error = validationObj.errMsg;

      if (!updatedInput.valid) isFormValid = false;

      updatedForm[key] = updatedInput;
      updatedPasswordDetails[key] = updatedInput.value;
    }

    if (isFormValid && oldPassword === newPassword) {
      for (let key in updatedForm) {
        const updatedInput = { ...updatedForm[key] };
        if (updatedInput.key === "newPassword") {
          updatedInput.valid = false;
          updatedInput.error = VALIDATION.auth.samePassword;
          isFormValid = false;
          updatedForm[key] = updatedInput;
          updatedPasswordDetails[key] = updatedInput.value;
          break;
        }
      }
    }

    setForm(updatedForm);

    if (isFormValid) {
      props.updatePasswordStart(updatedPasswordDetails);
    }
  }

  return (
    <React.Fragment>
      {objectToArray(form).map((input, index) => (
        <div className="err_msg_wrap" key={input.key}>
          <p className="popup_label">{input.title}</p>

          <div className="pwd-icon">
            <input
              type={input.type}
              className="input_text"
              onChange={e => inputChangeHandler(input.key, e.target.value)}
              autoFocus={input.key === "oldPassword"}
              value={input.value}
              autoComplete="off"
            />
            {input.key === "newPassword" && passwordStrength !== "" && (
              <div className={["pwd_strength", passwordStrength].join(" ")}>
                <div className="line"></div>
                <div className="text">{passwordStrength}</div>
              </div>
            )}
            <ShowHidePassword
              show={input.type === "text"}
              state={form}
              setState={setForm}
              path={input.key}
            />
          </div>

          {!input.valid && (
            <div>
              <span className="error-msg">{input.error}</span>
            </div>
          )}
        </div>
      ))}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    changePassword: state.account.changePassword
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { updatePasswordStart, updatePasswordResetState },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
